
import { Component, Prop, Vue } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { CreateElement } from "vue";
import { IClient } from "@/models/clients";
import { mapState } from "vuex";

@Component({
  components: {
    "notes-provider": () =>
      import("@/components/app/admin/notes/notesProvider.vue"),
    "add-edit-note": () =>
      import("@/components/app/admin/notes/addEditNote.vue"),
    notes: () => import("@/components/app/admin/notes/notes.vue")
  },
  computed: {
    ...mapState({
      clientScope(state, getters) {
        return getters[`data/${DataModules.CLIENTS}/scope`](this.clientId);
      }
    })
  }
})
export default class ClientNotes extends Vue {
  // Props

  @Prop({ required: true })
  public readonly clientId!: IClient["id"];

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  @Prop({ default: false })
  public readonly ignoreHistory!: boolean;

  // Data

  public readonly clientScope!: string;

  // Render function

  public render(h: CreateElement) {
    return h("notes-provider", {
      props: {
        canCreate: this.$userCan("create_client_note"),
        canDelete: this.$userCan("delete_client_note"),
        canEdit: this.$userCan("update_client_note"),
        canList: this.$userCan("list_client_notes"),
        dataScope: this.clientScope,
        id: "CN",
        ignoreHistory: this.ignoreHistory,
        module: DataModules.CLIENTS_NOTES,
        payload: {
          clientId: this.clientId
        }
      },
      scopedSlots: {
        default: () => {
          return h("div", {}, [
            h("add-edit-note", { props: { isDisabled: this.isDisabled } }),
            h("notes", { props: { isDisabled: this.isDisabled } })
          ]);
        }
      }
    });
  }
}
